import { createOlMap } from '../openlayers-utils/map-utils'
import CheckWebgl from '../utils/check-webgl';
import { createSelector } from 'redux-bundler';


export default {
  name: 'map',

  getReducer(){
    const initialState = {
      map2d: null,
      map3d: null,
      threeD: false,
      cursor: 'grab'
    }

    return (state = initialState, { type, payload }) => {

      if(type === 'MAP_CREATED'){
        return Object.assign({}, state, payload);
      }

      if(type === 'MAP_CURSOR_CHANGED'){
        return Object.assign({}, state, payload);
      }

      if(type === 'MAP_SWITCHED_DIMENSION'){
        return Object.assign({}, state, payload);
      }

      return state;
    }
  },

  doCreateMap: (options) => ({ dispatch, store }) => {
    const geoProjection = store.selectGeoProjection();
    const mapProjection = store.selectMapProjection();
    const basemaps = store.selectBasemapList();
    // @TODO move to config, need a better way to approach this.
    const defaultBasemapIdx = basemaps.length === 1 ? 0 : 1;
    const map2d = createOlMap(options, geoProjection, mapProjection);
    let map3d = null;
    // if(CheckWebgl()){
    //   //window.Cesium = Cesium;
    //   window.Cesium.Ion.defaultAccessToken = process.env.REACT_APP_CESIUM_ACCESS_TOKEN;
    //   map3d = new OLCesium({map: map2d});
    //   const scene = map3d.getCesiumScene();
    //   scene.terrainProvider = window.Cesium.createWorldTerrain();
    // }
    dispatch({type: 'MAP_CREATED', payload: { map2d: map2d, map3d: map3d }});
    store.doChangeBasemap(defaultBasemapIdx)
  },

  doSetCursor: (cursor) => ({ dispatch }) => {
    let c = cursor;
    if(!c) c = 'grab';
    dispatch({type: 'MAP_CURSOR_CHANGED', payload: {cursor: c} });
  },

  // doSwitchDimensions: (threeD) => ({ dispatch, store }) => {
  //   const olcs = store.selectCesium();
  //   olcs.setEnabled(threeD);
  //   olcs.enableAutoRenderLoop();
  //   store.doDeactivateBasicTool();
  //   dispatch({type: 'MAP_SWITCHED_DIMENSION', payload: { threeD: threeD }})
  // },

  selectCursorClass: (state) => {
    return state.map.cursor;
  },

  selectMap: (state) => {
    return state.map.map2d;
  },

  // selectCesium: (state) => {
  //   return state.map.map3d;
  // },

  // selectOlcsCamera: createSelector(
  //   'selectCesium',
  //   (olcs) => {
  //     if(!olcs) return null;
  //     return olcs.getCamera();
  //   }
  // ),

  // selectCesiumCamera: createSelector(
  //   'selectCesium',
  //   (olcs) => {
  //     if(!olcs) return null;
  //     return olcs.getCesiumScene().camera;
  //   }
  // ),

  selectThreeD: (state) => {
    return state.map.threeD;
  },

  selectView: (state) => {
    if(!state.map.map2d) return null;
    return state.map.map2d.getView();
  }
}